<template>
    <div class="h1" @click="to_api()">
        <div >
        </div >
        <!-- <div>
            <img @click="to_api()" style="width: 100%;height: 3.54rem;" src="../assets/imgs/qiwei101/1.gif" alt="">
        </div> -->
    </div>
</template>
<!-- mounted() {
    this.adid = this.$route.query.adid
    this.creativeid = this.$route.query.creativeid
    this.creativetype = this.$route.query.creativetype
    this.clickid = this.$route.query.clickid
    this.code = this.$route.query.code
    if (this.$route.query.adid == undefined) {
        this.adid = null
    }
    if (this.$route.query.creativeid == undefined) {
        this.creativeid = null
    }
    if (this.$route.query.creativetype == undefined) {
        this.creativetype = null
    }
    if (this.$route.query.clickid == undefined) {
        this.clickid = null
    }
}, -->
<script>
import axios from "axios"
// import { testdata } from '@/api/userApi.js'
export default {
    data() {
        return {
            adid: "",
            creativeid: "",
            creativetype: "",
            clickid: ""
        }
    },
    mounted() {
        this.adid = this.$route.query.adid
        this.creativeid = this.$route.query.creativeid
        this.creativetype = this.$route.query.creativetype
        this.clickid = this.$route.query.clickid
		this.addEnter()
    },
    methods: {
		addEnter(){
			let data = {
			              code: this.$route.query.code,
			          }
		
			          axios({
			              method: "GET",
			              url: "https://dy01.txcfgl.net:24080/v1/clutter/dataEnter?livecode=ca_104"
			              // url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
			          }).then(res => {
			          })
		},
        to_api() {
			
            let data = {
                adid: this.adid,
                creativeid: this.creativeid,
                creativetype: this.creativetype,
                clickid: this.clickid,
                code: this.$route.query.code,
            }
			setTimeout(() => {
				if(data.clickid!=undefined){
					var length=data.clickid.slice(46,76);
					window.location.href ="https://work.weixin.qq.com/ca/cawcde55a244f9b3e2?customer_channel=ca_104_"+length
				}else{
					window.location.href ="https://work.weixin.qq.com/ca/cawcde55a244f9b3e2?customer_channel=ca_104"
				}
			}, 300);
			axios({
				method: "GET",
				url: "https://dy01.txcfgl.net:24080/v1/clutter/save?"+"clickid=" + data.clickid + "&livecode=ca_104"
				// url: "http://172.16.2.154:8080/v1/applet/getUrl?adid=" + data.adid + "&creativeid=" + data.creativeid + "&creativetype=" + data.creativetype + "&clickid=" + data.clickid + "&code=" + data.code,
			}).then(ress => {
				
			})
            
        },
    },

}
</script>

<style>
.h1 {
    width: 100%;
    height: 12rem;
    background: url(../assets/imgs/erbu/ling.png);
    background-size: 100% 100%;
}

.imgs {
    padding-left: .5rem;
    padding-top: 7.83rem;
}

img {
    width: 6.5rem;
    height: 1.30rem;
}
</style>